import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { RedirectionComponent } from './redirection/redirection.component';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      { path: 'dimelo', component: RedirectionComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DimeloRoutingModule {}
